module.exports = __webpack_public_path__ + "static/media/52f8b457.jpg";